export const MODALS = {
    CREATE_TAG: 'CREATE_TAG',
    REMOVE_TAG: 'REMOVE_TAG',
    EDIT_TAG: 'EDIT_TAG',
}
